import React from "react";
import "./styles.scss";

const DataLabelCard = ({ title, description }) => {
  return (
    <div className="data-info-box">
      <div className="info-title">{title}</div>
      <div className="info-description">{description}</div>
    </div>
  );
};

export default DataLabelCard;
